module.exports = __webpack_public_path__ + "img/admin-new.36446db6.png";